<template>
  <div>
    <input ref="fileInput" type="file" accept=".jpg,.jpeg,.png,.webp" @change="onFileChange" hidden />
    <v-btn block color="primary" :loading="isUploading" :disabled="isUploading" @click="triggerFileSelect">
      {{ isUploading ? "Uploading…" : "Upload Image" }}
    </v-btn>
    <div v-if="error" class="caption error--text mt-1">{{ error }}</div>
  </div>
</template>

<script>
import { uploadRichTextImage } from "./uploadRichTextImage";

export default {
  data() {
    return {
      isUploading: false,
      error: "",
    };
  },
  methods: {
    triggerFileSelect() {
      if (this.isUploading) return;
      this.error = "";
      this.$refs.fileInput.value = "";
      this.$refs.fileInput.click();
    },
    async onFileChange(event) {
      const file = event.target.files?.[0];
      if (!file) return;

      this.isUploading = true;
      this.error = "";
      try {
        const selected = await uploadRichTextImage(file);
        this.$emit("select-file", selected);
      } catch (err) {
        console.error("Image upload failed:", err);
        const message =
          (typeof err === "string" && err) ||
          err?.response?.data ||
          err?.message ||
          "Image upload failed";
        this.error = typeof message === "string" ? message : "Image upload failed";
      } finally {
        this.isUploading = false;
        this.$refs.fileInput.value = "";
      }
    },
  },
};
</script>
